import React, { useEffect, useState } from "react";
import Styles from "./ClientHeader.module.scss";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import clsx from "clsx";
import { NavLink, useLocation } from "react-router-dom";
import { handleClearStoredAuth, notifyClientAuthChanged } from "../Func/Storage";
import useClientAuthSession from "../../Hooks/useClientAuthSession";
import { clientHome, subUrl, login, accuracy, rePass } from "../../Api/SubUrl";
import { useRef } from "react";

function ClientHeader() {
  const menuHorizontal = useRef();
  const location = useLocation();
  const handleClose = () => {
    menuHorizontal.current.click();
  };

  const handleLogout = () => {
    handleClose();
    handleClearStoredAuth();
    notifyClientAuthChanged();
  };

  const isAuthenticated = useClientAuthSession();
  const [isScrolled, setIsScrolled] = useState(false);
  const showLoginLink =
    !isAuthenticated &&
    (location.pathname === accuracy || location.pathname === rePass);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      className={clsx(Styles.Navbar, { [Styles.scrolled]: isScrolled })}
      bg="light"
      expand="lg"
    >
      <Container className={clsx(Styles.container)}>
        <Navbar.Brand className={clsx(Styles.brand)}>
          <NavLink className={clsx(Styles.BrandWrap)} to={clientHome}></NavLink>
        </Navbar.Brand>

        <Navbar.Toggle
          className={clsx(Styles.btn)}
          aria-controls="basic-navbar-nav"
          ref={menuHorizontal}
        />

        <Navbar.Collapse
          id="basic-navbar-nav"
          className={clsx(Styles.menuHorizontalWrap)}
        >
          <Nav className={clsx(Styles.menuHorizontal, "me-auto")}>
            {showLoginLink ? (
              <NavLink
                onClick={() => handleClose()}
                className={clsx(Styles.itemNav)}
                to={login}
              >
                <span className={clsx(Styles.itemHover)} />
                Login
              </NavLink>
            ) : null}

            {isAuthenticated ? (
              <>
                <NavLink
                  onClick={() => handleClose()}
                  className={clsx(Styles.itemNav)}
                  to={subUrl || "/"}
                >
                  <span className={clsx(Styles.itemHover)} />
                  Tài khoản
                </NavLink>

                <NavLink
                  onClick={handleLogout}
                  className={clsx(Styles.itemNav)}
                  to={subUrl || "/"}
                >
                  <span className={clsx(Styles.itemHover)} />
                  Đăng xuất
                </NavLink>
              </>
            ) : null}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default ClientHeader;
